var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowAccordionRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.756975 1.0881C0.82394 1.02114 0.900948 0.987654 0.988002 0.987654C1.07506 0.987654 1.15206 1.02114 1.21903 1.0881L5.89983 5.7689C5.9668 5.83587 6.00028 5.91288 6.00028 5.99993C6.00028 6.08698 5.9668 6.16399 5.89983 6.23096L1.21903 10.9118C1.15206 10.9787 1.07506 11.0122 0.988002 11.0122C0.900948 11.0122 0.82394 10.9787 0.756975 10.9118L0.254743 10.4095C0.187779 10.3426 0.154297 10.2656 0.154297 10.1785C0.154297 10.0914 0.187779 10.0144 0.254743 9.94747L4.20229 5.99993L0.254743 2.05239C0.187779 1.98542 0.154297 1.90841 0.154297 1.82136C0.154297 1.7343 0.187779 1.6573 0.254743 1.59033L0.756975 1.0881Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAccordionRight);
export default __webpack_public_path__ + "static/media/arrow-accordion-right.f3ef9161fbfe369052b4da52c8d03fbb.svg";
export { ForwardRef as ReactComponent };